<template>
  <teleport to="body">
    <overlay
      key="ShoppingGivesModal"
      block-class="shopping-gives-modal"
      direction="up"
      namespace="ShoppingGivesModal"
      type="modal"
      show-overlay
      show-close
    >
      <template #body>
        <div class="shopping-gives-modal__wrapper">
          <h3
            class="shopping-gives-modal__header"
            v-html="content.header"
          />

          <responsive-image
            class="shopping-gives-modal__image"
            :image="getImage(content.image)"
            lazyload
            ratio="100:30"
            sizes="50vw"
          />

          <responsive-image
            class="shopping-gives-modal__powered-by-image"
            :image="getImage(content.poweredBy)"
            lazyload
            ratio="50:1"
            sizes="50vw"
          />

          <div
            class="shopping-gives-modal__footer text-heading-l"
            v-html="content.footer"
          />
        </div>
      </template>
    </overlay>
  </teleport>
</template>

<script>

/**
 * Vue: Shopping gives modal (shopping-gives-modal)
 * -----------------------------------------------------------------------------
 * Custom shopping gives modal.
 *
 */
import { mapActions } from 'vuex'
import Overlay from '~global/overlay/overlay'
import ResponsiveImage from '~global/images/responsive-image'

export default {
  name: 'ShoppingGivesModal',

  components: {
    Overlay,
    ResponsiveImage,
  },

  props: {
    content: {
      type: Object,
      default: () => ({
        header: '',
        image: null,
        poweredBy: null,
        footer: '',
      }),
    },
  },

  methods: {

    /*
    * Map Vuex actions.
    */
    ...mapActions({
      closeOverlay: 'overlays/close',
    }),

    /**
    * Close modal
    */
    closeSGModal() {
      this.closeOverlay('ShoppingGivesModal')
    },

    /**
    * Get image
    */
    getImage(image) {
      return {
        src: image,
      }
    },
  },
}
</script>

<style lang="scss">
  @import './shopping-gives-modal';
</style>
